(function () {
    function initAccordion(root) {
        if (!root || root.dataset.accordionReady === '1') {
            return;
        }

        root.dataset.accordionReady = '1';

        root.addEventListener('click', (event) => {
            const head = event.target.closest('[class$="__head"]');

            if (!head || !root.contains(head)) {
                return;
            }

            const item = head.closest('[class$="__item"]');

            if (!item) {
                return;
            }

            const isOpen = item.classList.contains('is-open');
            item.classList.toggle('is-open', !isOpen);
            head.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

            const title = head.querySelector('[class$="__head-title"], [class$="__question"]');
            const label = title ? title.textContent.trim() : '';

            if (label) {
                head.setAttribute(
                    'aria-label',
                    isOpen ? `Atidaryti: ${label}` : `Uždaryti: ${label}`
                );
            }
        });
    }

    function initSchedule(block) {
        if (!block || block.dataset.scheduleReady === '1') {
            return;
        }

        block.dataset.scheduleReady = '1';

        const accordion = block.querySelector('[data-rutina-accordion]');
        initAccordion(accordion);
    }

    function expandAllAccordions() {
        document.querySelectorAll('[data-rutina-accordion] [class$="__item"]').forEach((item) => {
            item.classList.add('is-open');
            const head = item.querySelector('[class$="__head"]');

            if (head) {
                head.setAttribute('aria-expanded', 'true');
            }
        });
    }

    function boot() {
        document.querySelectorAll('[data-rutina-schedule]').forEach(initSchedule);
    }

    window.addEventListener('beforeprint', expandAllAccordions);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
        boot();
    }
})();
